var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 13.5 13.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41667 3.05727H10.4167M10.4167 3.05727H12.4167M10.4167 3.05727V5.08333M10.4167 3.05727V1.08333M12.75 11.5833V9.25C12.75 8.60567 12.2277 8.08333 11.5833 8.08333H9.25C8.60567 8.08333 8.08333 8.60567 8.08333 9.25V11.5833C8.08333 12.2277 8.60567 12.75 9.25 12.75H11.5833C12.2277 12.75 12.75 12.2277 12.75 11.5833ZM5.41667 4.25V1.91667C5.41667 1.27234 4.89433 0.75 4.25 0.75H1.91667C1.27233 0.75 0.75 1.27234 0.75 1.91667V4.25C0.75 4.89433 1.27233 5.41667 1.91667 5.41667H4.25C4.89433 5.41667 5.41667 4.89433 5.41667 4.25ZM5.41667 11.5833V9.25C5.41667 8.60567 4.89433 8.08333 4.25 8.08333H1.91667C1.27233 8.08333 0.75 8.60567 0.75 9.25V11.5833C0.75 12.2277 1.27233 12.75 1.91667 12.75H4.25C4.89433 12.75 5.41667 12.2277 5.41667 11.5833Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.34dd89b011ba1272127b0355147e8338.svg";
export { ForwardRef as ReactComponent };